import Vue from "vue";
import axios from "axios";
import store from "@/store";
import { logger } from "@/plugins/functions";

let linkLang = null;

try {
  const urlParams = new URLSearchParams(window.location.search);
  linkLang = urlParams.get("l");
} catch (error) { }

Vue.prototype.$http = axios;

if (typeof Storage !== "undefined") {
  if (localStorage.getItem("device")) {
    Vue.prototype.$http.defaults.headers.common[
      "device"
    ] = localStorage.getItem("device");
  } else {
    const uid = ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
      (
        c ^
        (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
      ).toString(16)
    );
    localStorage.setItem("device", uid);
    Vue.prototype.$http.defaults.headers.common["device"] = uid;
  }

  let lang = localStorage.getItem("lang")
    ? localStorage.getItem("lang")
    : linkLang
      ? linkLang
      : "ru";

  let shop = localStorage.getItem("shop");

  if (shop) {
    let shopObject = JSON.parse(shop);
    if (shopObject && shopObject.id) {
      store.dispatch("setShop", shopObject);
      Vue.prototype.$http.defaults.headers.common["shop"] = shopObject.id;
    }
  } else {
    Vue.prototype.$http.defaults.headers.common["shop"] = "";
  }

  Vue.prototype.$http.defaults.headers.common["Accept"] = "application/json";

  Vue.prototype.$http.defaults.headers.common["version"] = "v1.997.40";

  Vue.prototype.$http.defaults.headers.common["tab"] =
    new Date() * Math.random(9999);

  store.dispatch("setLanguageCurrent", lang);

  localStorage.setItem("lang", lang);

  let UserToken = localStorage.getItem("token");
  let bid = localStorage.getItem("bid");
  let root = localStorage.getItem("root");

  if (UserToken) {
    Vue.prototype.$http.defaults.headers.common["Authorization"] = UserToken;
  }

  if (lang) {
    Vue.prototype.$http.defaults.headers.common["localization"] = lang;
  }

  if (bid) {
    Vue.prototype.$http.defaults.headers.common["bid"] = bid;
  } else if (root) {
    Vue.prototype.$http.defaults.headers.common["root"] = root;
  }
}

if (navigator) {
  if (!navigator.onLine) {
    alert("NO INTERNET!");
  }
}

Vue.prototype.$http.defaults.baseURL = process.env.URL_HOST;

Vue.prototype.$http.interceptors.request.use(
  (config) => {
    // console.log(config.method);
    try {
      if (
        (config.method == "put" ||
          config.method == "post" ||
          config.method == "delete") &&
        (config.url != "logs" &&
          config.url != "words")
      ) {
        logger(axios, {
          name: "start",
          url: config.url,
          method: config.method,
          status: 0,
          req: JSON.stringify(config.data),
        });
      }
    } catch (error) { }

    return config;
  },
  (error) => {
    logger(axios, { name: "start_error" });

    return Promise.reject(error);
  }
);

try {
  Vue.prototype.$http.interceptors.response.use(
    (response) => {
      // console.log(response);

      try {
        if (
          (response.config.method == "put" ||
            response.config.method == "post" ||
            response.config.method == "delete") &&
          (response.config.url != "logs" && response.config.url != "words")
        ) {
          let data = {};

          if (response.config.url != "auth") {
            data = response.data;
          }

          logger(axios, {
            name: "end",
            url: response.config.url,
            method: response.config.method,
            status: response.status,
            req: JSON.stringify(response.config.data),
            data: JSON.stringify(data),
          });
        }
      } catch (error) {
        // console.log(error);
      }

      return response;
    },
    (error) => {
      // console.log(error.response);
      if (error.response.status == "400") {
      }
      if (error.response.status == "401") {

        try {
          if (error.response.config.url != "auth" && error.response.config.url != "logs") {
            alert("Устарел токен");
          }
        } catch (error) {

        }
      }
      if (error.response.status == "422") {
      }
      if (error.response.status == "500") {
      }
      if (error.response.status == "429") {
        alert(
          "Слишком много запросов в систему. Через 1 минуту можете продолжить"
        );
      }


      try {
        if (
          (error.response.config.method == "put" ||
            error.response.config.method == "post" ||
            error.response.config.method == "delete") &&
          (error.response.config.url != "logs" && error.response.config.url != "words")
        ) {
          let data = {};

          if (error.response.config.url != "auth") {
            data = error.response.data;
          }

          // console.log(data);

          logger(axios, {
            name: "end_error",
            url: error.response.config.url,
            method: error.response.config.method,
            status: error.response.status,
            req: JSON.stringify(error.response.config.data),
            data: JSON.stringify(data),
          });
        }
      } catch (error) {
        // console.log(error);
      }

      return Promise.reject(error);
    }
  );
} catch (error) {
  alert("NO INTERNET!");
}

export default Vue.prototype.$http;
